import { render, staticRenderFns } from "./icon_nav-arrow.vue?vue&type=template&id=3147518a&scoped=true&"
var script = {}
import style0 from "./icon_nav-arrow.vue?vue&type=style&index=0&id=3147518a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147518a",
  null
  
)

export default component.exports